import i18next from 'i18next';

function getCurrentLanguageCode() {
  const { language } = i18next;

  return language.split('-')[0];
}

export default getCurrentLanguageCode;
